import { CaretPositionSuffixTypes, RuleEditorDropdownMode } from '../../NodeEditorDrawer/types';

export const ruleLineWrapperSideMap = {
  left: {
    caret: {
      action: CaretPositionSuffixTypes.THRESHOLD_LEFT_ACTION,
      attribute: CaretPositionSuffixTypes.THRESHOLD_LEFT_ATTRIBUTE,
    },
    dropdown: {
      action: RuleEditorDropdownMode.THRESHOLD_LEFT_ACTION,
      attribute: RuleEditorDropdownMode.THRESHOLD_LEFT_ATTRIBUTE,
    },
  },
  right: {
    caret: {
      action: CaretPositionSuffixTypes.THRESHOLD_RIGHT_ACTION,
      attribute: CaretPositionSuffixTypes.THRESHOLD_RIGHT_ATTRIBUTE,
    },
    dropdown: {
      action: RuleEditorDropdownMode.THRESHOLD_RIGHT_ACTION,
      attribute: RuleEditorDropdownMode.THRESHOLD_RIGHT_ATTRIBUTE,
    },
  },
};

export const validRightSideAttributeCaretTypes = [
  CaretPositionSuffixTypes.THRESHOLD_RIGHT_ACTION,
  CaretPositionSuffixTypes.THRESHOLD_RIGHT_ATTRIBUTE,
  CaretPositionSuffixTypes.THRESHOLD_RIGHT_ATTRIBUTE_VALUE,
  CaretPositionSuffixTypes.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_RANGE_MIN,
  CaretPositionSuffixTypes.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_RANGE_MAX,
  CaretPositionSuffixTypes.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_BOOLEAN,
  CaretPositionSuffixTypes.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_REASONCODEGROUP,
  CaretPositionSuffixTypes.THRESHOLD_RIGHT_ATTRIBUTE_VALUE_MULTISELECT,
  CaretPositionSuffixTypes.THRESHOLD_RIGHT_TAGACTIONRESULT,
];

export const validGroupingCaretTypes = [
  CaretPositionSuffixTypes.GROUP_END,
  CaretPositionSuffixTypes.GROUP_START,
];

export const validLeftSideCaretTypes = [
  CaretPositionSuffixTypes.THRESHOLD_LEFT_ACTION,
  CaretPositionSuffixTypes.THRESHOLD_LEFT_ATTRIBUTE,
];

export const ambiguousRuleOperatorType = {
  BEFORE_AMBIGUOUS_RULE: 'before_ambiguous_rule',
  WITHIN_AMBIGUOUS_RULE: 'within_ambiguous_rule',
};
